import { Component, h } from 'preact';
import { TcrAppBar } from './app-bar';
import { TcrMenuBar } from './menu-bar';
import { TcrContentView } from './content-view';
import { TcrMessageBox } from './message-box';
import { TcrPromptBox } from './prompt-box';
import { TcrContextMenu } from './context-menu';
import { TcrFooter } from './footer';
import { TcrProgressBox } from './progress-box';
import { TcrViewer } from './viewer';
import { TcrPwaPrompt } from './pwa-prompt';

class TcrUserInterface extends Component
{
    constructor(props)
    {
        super(props);

		this.toggleMenu = this.toggleMenu.bind(this);
		this.closeMenu = this.closeMenu.bind(this);
        this.updateTheme = this.updateTheme.bind(this);

        this.updateTheme();
        window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', this.updateTheme);
    }

    componentDidMount()
    {
        //prevent accidental drop of files.
        window.addEventListener("dragover",function(e){
            e = e || event;
            e.preventDefault();
        },false);
        window.addEventListener("drop",function(e){
            e = e || event;
            e.preventDefault();
        },false);
    }

    onError(e)
    {
        return MessageBox.show(e);
    }

    updateTheme()
    {
        if (this.props.theme == 'dark' || (this.props.theme != 'light' && window.matchMedia('(prefers-color-scheme: dark)').matches))
        {
            document.body.classList.add('dark');
        }
        else
        {
            document.body.classList.remove('dark');
        }
    }

    toggleMenu()
	{
		this.setState(prev => {
            return {
                showMenu: !prev.showMenu
            };
        });
	}

    closeMenu()
	{
		this.setState({
            showMenu: false
        });
	}

    preventContextMenu(e)
    {
        if (!e.shiftKey)
        {
            e.preventDefault();
        }
    }

    preventWheel(e)
    {
        if (e.ctrlKey || e.metaKey)
        {
            e.preventDefault();
        }
    }

    preventKeyZoom(e)
    {
        let isMac = /(Mac)/i.test((navigator || {}).platform);
        let CmdOrCtrl = isMac ? e.metaKey : e.ctrlKey;

        if ((e.ctrlKey || e.metaKey) && (e.keyCode === 61 || e.keyCode === 173 || e.keyCode === 48))
        {
            e.preventDefault();
        }
    }

    render()
    {
        return (
            <div class="tcr-user-interface" tabindex="-1" id={this.props.id} data-menu={this.state.showMenu} style={{'--accent': this.props.accent || '#BB4A3F'}} onContextMenu={this.preventContextMenu} onWheel={this.preventWheel} onKeyDown={this.preventKeyZoom} >
				<TcrAppBar onToggleMenu={this.toggleMenu} hasMenu={!!this.props.config.menuBar} showMenu={this.state.showMenu} config={this.props.config.appBar} />
                <TcrMenuBar showMenu={this.state.showMenu} onClose={this.closeMenu} config={this.props.config.menuBar} />
                <TcrContentView showMenu={this.state.showMenu} config={this.props.config.contentView}/>
                <TcrPwaPrompt />
                <TcrProgressBox />
                <TcrMessageBox />
                <TcrPromptBox />
                <TcrContextMenu />
                <TcrViewer />
                <TcrFooter config={this.props.config.footer} />
                {this.props.children}
			</div>
        );
    }
}

export { TcrUserInterface };